import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledCenteredStack = styled(Stack)({
	alignItems: "center",
	justifyContent: "center",
	height: "100%",
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
});
